import React from 'react';
import { useTranslation } from 'react-i18next';
import CardHistoryDate from './CardHistoryDate';

type CardHistoryProps = {
  dates: string[];
  history: any;
};

export default function CardHistory({ dates, history }: CardHistoryProps) {
  const [t] = useTranslation('global');

  return (
    <>
      <h1 className="h1 h1plus ion-text-center">{t('cardhistory.title')}</h1>
      <p className="pt-2 pb-3 instructions ion-text-center">
        {t('cardhistory.info')} <a target={"_blank"} href={t('cardhistory.info_link_href') ?? undefined} rel="noreferrer">{t('cardhistory.info_link_text')}</a>.
      </p>

      {dates &&
        dates.map((date: string, i: number) => {
          return <CardHistoryDate key={i} date={date} history={history} />;
        })}
    </>
  );
}
